import { Stack } from '@mui/material';
import { useDataProvider, useLocalization } from '@ui-framework/index';
import { PageSection } from '@product-framework/index';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import DispatchNotifications from '../../../components/DispatchNotifications';
import InsightContact from '../../../components/InsightContact';
import getConfig from '../../../configs/sp-location-config';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../utils/getSPLevelStackableButtons';

function LocationSetup() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const { serviceProviderId, locationId, refreshData } = useServiceProvider();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl } = useDataProvider(provider);

  const config = getConfig({
    apiBaseUrl: getApiUrl(),
    serviceProviderId,
    locationId,
  });

  const onChange = () => {
    refreshData({
      refreshLocation: true,
      refreshProfileWarnings: true,
    });
  };

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_SETUP"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        label={formatMessage({
          id: 'LOCATION_SETUP',
          defaultMessage: 'Location Setup',
        })}>
        <Stack spacing={4} sx={{ width: '100%' }}>
          <DispatchNotifications
            config={config}
            isLocationScope
            onChange={onChange}
          />
          <InsightContact config={config} isLocationScope onChange={onChange} />
        </Stack>
      </PageSection>
    </ServiceProviderLayout>
  );
}

const LocationSetupObserver = observer(LocationSetup);
export default withServiceProvider(LocationSetupObserver);
